import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import ReactTable from 'react-table'
import { Field } from 'redux-form'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import { Button } from 'semantic-ui-react'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { getPaymentBlocks, getPaymentMethods, getPaymentTerms, getSortKeys, getWhtTypes, 
  getWhtReceiptTypes, getReconciliations, getPlanningGroups, getTradingPartners } from 'ducks/options'
import { AccountingInformationContainer, SubDetailContainer } from './styled'
import { WithholdingTaxForm } from '../'
import { columnWht } from '../../AttributeData'
import { getBPAccountingView } from 'ducks/vendorMaintenance'
// import r from 'reactotron-react-js'

const AccountingInformation = (props) => {
  const { valueForm, change, paymentBlocks, paymentMethods, paymentTerms, 
    sortKeys, whtTypes, whtReceiptTypes, isDisplay, reconciliations,
    planningGroups, tradingPartners } = props
  const withholdingTaxs = valueForm && valueForm.withholdingTaxs ? valueForm.withholdingTaxs : []

  const [showAccountingInfo, setShowAccountingInfo] = useState(true)
  const [showWithholdingTaxForm, setShowWithholdingTaxForm] = useState(false)
  const [whtTaxData, setWhtTaxData] = useState(undefined)
  
  useEffect(() => {
    if (!paymentBlocks.data.length && !paymentBlocks.loading) {
      props.getPaymentBlocks()
    }

    if (!paymentMethods.data.length && !paymentMethods.loading) {
      props.getPaymentMethods()
    }

    if (!paymentTerms.data.length && !paymentTerms.loading) {
      props.getPaymentTerms()
    }
    
    if (!sortKeys.data.length && !sortKeys.loading) {
      props.getSortKeys()
    }

    if (!whtTypes.data.length && !whtTypes.loading) {
      props.getWhtTypes()
    }

    if (!whtReceiptTypes.data.length && !whtReceiptTypes.loading) {
      props.getWhtReceiptTypes()
    }

    if (!planningGroups.data.length && !planningGroups.loading) {
      props.getPlanningGroups ()
    }

    if (!tradingPartners.data.length && !tradingPartners.loading) {
      props.getTradingPartners()
    }
  }, [])

  useEffect(() => {
    if (valueForm.companyCode !== undefined) {
      if (reconciliations.companyCode !== valueForm.companyCode) {
        props.getReconciliations(valueForm.companyCode)
      }
    }
  }, [valueForm.companyCode])

  const onSubmitWithholdingTax = (data, isNew, oldData) => {
    if (isNew) {
      change('withholdingTaxs', [...withholdingTaxs, data])
    } else {
      const index = withholdingTaxs.findIndex(u => u.email === oldData.email)
      withholdingTaxs[index] = data
      change('withholdingTaxs', [...withholdingTaxs])
    }
  }

  const showModalEditWithholdingTax = (userIndex) => {
    setWhtTaxData(withholdingTaxs[userIndex])
    setShowWithholdingTaxForm(true)
  }

  const onDeleteWithholdingTax = (userIndex) => {
    withholdingTaxs.splice(userIndex, 1)
    change('withholdingTaxs', [...withholdingTaxs])
  }

  const editableForm = () => {
    const { purpose, status, sn, accountingViewLoaded } = valueForm

    if (purpose === 'create') {
      if (status === 0 || status === undefined) {
        return !isDisplay
      } else {
        return !isDisplay && 
             (sn !== undefined && sn !== null && sn !== '')
      }
      
    } else if (purpose === 'change') {
      if (status === undefined || status === 0) {
        // new document (ZRPT)
        return !isDisplay && accountingViewLoaded
      } else {
        // edit or submit document
        return !isDisplay && accountingViewLoaded && 
             (sn !== undefined && sn !== null && sn !== '')
      }
    } else {
      return !isDisplay
    }
  }

  const showLoadButton = () => {
    if ((valueForm.accountGroup === 'ZRPT'||valueForm.accountGroup === 'ZRCP')) {
      if (valueForm.status === undefined || valueForm.status === 0) {
        return true
      }
    }
    return valueForm.purpose === 'change' && (valueForm.sn || (valueForm.accountGroup === 'ZRPT'||valueForm.accountGroup === 'ZRCP')) && valueForm.status === 2
  }

  const showAccForm = () => {
    if (valueForm.purpose === 'change') {
      return valueForm.accountingViewLoaded
    } else {
      return true
    }
  }

  const onLoadAccountingViewSuccess = (data) => {
    const getBoolValue = (value, defaultValue) => {
      return (value !== undefined && value !== null && value !== '') ? value : defaultValue
    }

    change('reconciliationAccount', data.reconciliationAccount || '')
    change('sortKey', data.sortKey || '')
    change('planningGroup', data.planningGroup || '')
    change('accPaymentTerms', data.accPaymentTerms || '')
    change('paymentMethod', data.paymentMethod || [])
    change('paymentBlock', data.paymentBlock || '')
    change('tradingPartner', data.tradingPartner || '')
    change('previousAccount', data.previousAccount || '')
    change('checkDoubleInvoice', getBoolValue(data.checkDoubleInvoice, false))
    change('payeeInDocument', getBoolValue(data.payeeInDocument, false))
    change('withholdingTaxs', [...(data.withholdingTaxs || [])])
    change('branchCode', data.branchCode || '')
    change('branchDescription', data.branchDescription || '')
    change('accountingViewLoaded', true)
  }

  return (
    <React.Fragment>
      <Card style={{ marginTop: '10px' }}>
        <CardHeader 
          title='Accounting Information'
          action={
            <IconButton aria-label='Expand' onClick={() => setShowAccountingInfo(!showAccountingInfo) }>
              {showAccountingInfo ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          }
        />
        <Collapse in={showAccountingInfo}>
          <CardContent>
            <AccountingInformationContainer>
              {
                showLoadButton() ?
                  <div className='rowFields'>
                    <div style={{ flex: 1 }} />
                    <div>
                      <Button 
                        color='blue'
                        content='Load'
                        type='button'
                        style={{marginRight: '15px' }}
                        disabled={
                          (valueForm.companyCode === undefined ||
                          valueForm.companyCode === null ||
                          valueForm.companyCode === '')
                        }
                        onClick={() => {
                          // Load accounting view
                          props.getBPAccountingView(valueForm.vendorCode, valueForm.companyCode, onLoadAccountingViewSuccess)
                        }}
                      />
                    </div>
                  </div> : null
              }
              {
                showAccForm() ?
                  <React.Fragment>
                    <div className='rowFields'>
                      <Field 
                        name='reconciliationAccount'
                        label='Reconciliation Account'
                        require
                        loading={reconciliations.loading}
                        options={reconciliations.data}
                        editable={editableForm()}
                        type={type.select}
                        component={FieldInput} />
                      <Field 
                        name='sortKey'
                        label='Sort Key'
                        require
                        loading={sortKeys.loading} 
                        options={sortKeys.data} 
                        editable={editableForm()}
                        type={type.select} 
                      component={FieldInput} />
                    </div>
                    <div className='rowFields'>
                      <Field 
                        name='planningGroup' 
                        label='Planning Group'
                        require
                        loading={planningGroups.loading}
                        options={planningGroups.data}
                        editable={editableForm()}
                        type={type.select}
                        component={FieldInput} />
                      <Field 
                        name='accPaymentTerms' 
                        label='Payment Terms'
                        require
                        loading={paymentTerms.loading}
                        options={paymentTerms.data}
                        editable={editableForm()}
                        type={type.select}
                        component={FieldInput} />
                    </div>
                    <div className='rowFields'>
                      <Field 
                        name='paymentMethod' 
                        label='Payment Method'
                        require
                        loading={paymentMethods.loading}
                        options={paymentMethods.data}
                        editable={editableForm()}
                        type={type.multiSelect}
                        component={FieldInput} />
                      <Field 
                        name='paymentBlock' 
                        label='Payment Block'
                        loading={paymentBlocks.loading}
                        options={paymentBlocks.data}
                        editable={editableForm()}
                        type={type.select}
                        component={FieldInput} />
                    </div>
                    <div className='rowFields'>
                      <Field 
                        name='tradingPartner' 
                        label='Trading Partner'
                        require={valueForm.accountGroup === 'ZRPT'||valueForm.accountGroup === 'ZRCP'}
                        loading={tradingPartners.loading}
                        options={tradingPartners.data}
                        editable={editableForm()}
                        type={type.select}
                        component={FieldInput} />
                      <Field 
                        name='previousAccount' 
                        label='Previous Account'
                        editable={editableForm()}
                        type={type.text}
                        component={FieldInput} />
                    </div>
                    <div className='rowFields'>
                      <Field 
                        name='checkDoubleInvoice' 
                        label='Check Double Invoice'
                        editable={false}
                        type={type.checkbox}
                        component={FieldInput} />
                      <Field 
                        name='payeeInDocument' 
                        label='Payee in Document'
                        editable={editableForm()}
                        type={type.checkbox}
                        component={FieldInput} />
                    </div>
                    <SubDetailContainer>
                      <div className='subTitle'>Withholding Tax</div>
                      {
                        editableForm() ?
                          <div className='rowFields'>
                            <Button 
                              color='blue'
                              content='Add Withholding'
                              type='button'
                              style={{ flex: 1 }}
                              onClick={() => setShowWithholdingTaxForm(true)}
                            />
                            <div style={{ flex: 1 }} />
                          </div> : null
                      }
                      {
                        withholdingTaxs.length ?
                          <ReactTable
                            data={withholdingTaxs}
                            columns={
                              columnWht({ 
                                withActions: editableForm(),
                                showWhtModal: showModalEditWithholdingTax, 
                                onDeleteWht: onDeleteWithholdingTax,
                                whtTypeOptions: whtTypes.data,
                                whtReceiptTypeOptions: whtReceiptTypes.data
                              })
                            }
                            pageSize={withholdingTaxs.length}
                            defaultPageSize={withholdingTaxs.length}
                            className='-striped -highlight'
                            showPagination={false}
                          /> : null
                      }
                    </SubDetailContainer>
                    <SubDetailContainer>
                      <div className='subTitle'>Branch</div>
                      <div className='rowFields'>
                        <Field 
                          name='branchCode'
                          label='Branch Code'
                          require
                          editable={editableForm()}
                          type={type.text}
                          component={FieldInput} />
                        <Field 
                          name='branchDescription'
                          label='Description'
                          require
                          editable={editableForm()}
                          type={type.text} 
                        component={FieldInput} />
                      </div>
                    </SubDetailContainer>
                  </React.Fragment> : null
              }
            </AccountingInformationContainer>
          </CardContent>
        </Collapse>
      </Card>
      {
        showWithholdingTaxForm ? 
          <WithholdingTaxForm 
            whtTaxData={whtTaxData}
            listWht={withholdingTaxs}
            clearWhtTaxData={setWhtTaxData}
            showWhtModal={setShowWithholdingTaxForm} 
            onSubmitWithholdingTax={onSubmitWithholdingTax}
          /> : null
      }
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return ({
    paymentBlocks: state.options.paymentBlocks,
    paymentMethods: state.options.paymentMethods,
    paymentTerms: state.options.paymentTerms,
    sortKeys: state.options.sortKeys,
    whtTypes: state.options.whtTypes,
    whtReceiptTypes: state.options.whtReceiptTypes,
    reconciliations: state.options.reconciliations,
    planningGroups: state.options.planningGroups,
    tradingPartners: state.options.tradingPartners,
  })
}
  
const mapDispatchToProps = {
  getPaymentBlocks,
  getPaymentMethods,
  getPaymentTerms,
  getSortKeys,
  getWhtTypes, 
  getWhtReceiptTypes,
  getReconciliations,
  getPlanningGroups, 
  getTradingPartners,
  getBPAccountingView
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountingInformation)